export default __webpack_public_path__ + "static/media/dish2.eb9cc943.png";